<div class="item-label {{ colorClass }}" [class.hidden-by-quick-filter]="hiddenByQuickFilter">
  <img [src]="imgPrefix + icon" class="base-type-image">
  {{ equipment.displayName }}
</div>
